import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../entities/ErrorEntity";
import SearchResultEntity from "../entities/SearchResultEntity";
import StablishmentEntity from "../entities/StablishmentEntity";
import ScheduleEntity, { ScheduleDay } from "../entities/ScheduleEntity";

export default interface StablishmentRepository {
    createStablishment(stablishment: StablishmentEntity): Promise<Either<ErrorEntity, StablishmentEntity>>;
    searchStablishments(_: {
    query?: string, 
    page: number, 
    itemsPerPage: number
}): Promise<Either<ErrorEntity, SearchResultEntity<StablishmentEntity>>>;
    getStablishmentById(id: string): Promise<Either<ErrorEntity, StablishmentEntity>>;
    deleteStablishment(id: string): Promise<Either<ErrorEntity, void>>;
    updateStablishment(stablishment: StablishmentEntity): Promise<Either<ErrorEntity, StablishmentEntity>>;
    getSchedulesByStablishmentAndDay(stablishmentId: string, day: Date): Promise<Either<ErrorEntity, ScheduleEntity[]>>;
    deleteSchedule(id: string): Promise<Either<ErrorEntity, void>>;
}

export const StablishmentRepositoryName = "StablishmentRepository";